module.exports = __webpack_public_path__ + "img/soft_18.59a15e17.png";